import { render } from "./CsvForm.vue?vue&type=template&id=1bc5a5f4"
import script from "./CsvForm.vue?vue&type=script&lang=js"
export * from "./CsvForm.vue?vue&type=script&lang=js"
script.render = render

export default script